
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleConsultationClick = () => {
    const ctaSection = document.querySelector('[data-cta-section]');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/8ddfb7f039f8fb7ecfda22dea6960c34.webp)'
        }}
      ></div>

      {/* コンテンツ */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-3 sm:px-4 md:px-6 py-6 sm:py-8 md:py-12">
        <div className="flex items-center justify-start">
          <div className="text-white max-w-4xl">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-bold mb-3 sm:mb-4 md:mb-6 leading-tight">
              <span className="text-[#76B947]">スマート農業</span>で<br />
              未来を変える<br className="sm:hidden" />お手伝い
            </h1>
            
            <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl mb-4 sm:mb-6 md:mb-8 leading-relaxed font-medium">
              IDS 教習所グループではDJI 農業ドローンをはじめ、<br className="hidden lg:block" />
              FJD 農機自動操舵システムやFarmo 水管理システムに至るまで、<br className="hidden lg:block" />
              様々なスマート農業機器を販売しております。<br className="hidden lg:block" />
              お客様にあわせて最適なスマート農業機器をご提案致します。
            </p>

            <div className="flex flex-col gap-2 sm:gap-3 md:gap-4 justify-start items-start mb-4 sm:mb-6 md:mb-8">
              <button 
                onClick={handleConsultationClick}
                className="px-3 py-2 sm:px-4 sm:py-3 md:px-6 md:py-4 lg:px-8 lg:py-4 xl:px-10 xl:py-5 bg-[#FFC107] text-black rounded-lg hover:bg-yellow-500 transition-colors text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl font-bold whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
              >
                まずは専門家に無料で相談する
              </button>
            </div>

            {/* 取扱メーカー */}
            <div className="opacity-90">
              <span className="text-xs sm:text-sm md:text-base lg:text-lg text-gray-300 mb-2 sm:mb-3 block font-medium">取扱メーカー</span>
              <div className="flex flex-wrap justify-start items-center gap-1 sm:gap-2 md:gap-3">
                <div className="bg-white/20 backdrop-blur-sm px-2 py-1 sm:px-3 sm:py-2 rounded-lg">
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base lg:text-lg">DJI Agriculture</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 py-1 sm:px-3 sm:py-2 rounded-lg">
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base lg:text-lg">FJDynamics</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 py-1 sm:px-3 sm:py-2 rounded-lg">
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base lg:text-lg">EFIX</span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm px-2 py-1 sm:px-3 sm:py-2 rounded-lg">
                  <span className="text-white font-bold text-xs sm:text-sm md:text-base lg:text-lg">Farmo</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
